import { Button, ButtonProps } from '@akin-home/buttons/native';

export const ScreenDeleteButton = (props: ButtonProps) => (
  <Button
    icon="trash"
    size="large"
    iconSize={20}
    variant="secondary"
    {...props}
  >
    Delete
  </Button>
);
